<template>
  <footer class="text-white pt-5">
    <div class="container">
      <div class="row">
        <!-- Kiri -->
        <div class="col-12 col-md-6 mb-4">
          <img
            :src="EfundingWhiteLogo"
            alt="Logo"
            class="mb-3"
            style="max-width: 150px"
          />
          <div class="address-container">
            <p style="font-weight: 600; font-size: 18px; margin-bottom: 10px; color: #f7bd3a">
              TERDAFTAR DAN DIAWASI OLEH OJK - SURAT NOMOR S-61/IK.01/2025
            </p>
            <p
              class="text-white"
              style="font-weight: 600; font-size: 18px; margin-bottom: 10px"
            >
              Ruby Commercial TB21
            </p>
            <p
              class="text-white"
              style="font-weight: 600; font-size: 18px; margin-bottom: 10px"
            >
              Summarecon Bekasi
            </p>
            <p class="text-white" style="margin-bottom: 10px">
              Jalan Bulevar Selatan, RT.003/RW.005, Kelurahan Marga Mulya,
              Kecamatan Bekasi Utara, Kota Bekasi, Jawa Barat 17143
            </p>

            <div class="col mx-0 px-0">
              <div class="row">
                <div class="col-4 col-md-2">Whatsapp</div>
                <div class="col-8 col-md-10">: +62 818-227-070</div>
              </div>
              <div class="row">
                <div class="col-4 col-md-2">Jam Kerja</div>
                <div class="col-8 col-md-10">: Senin–Jumat (09:00–17:00)</div>
              </div>
              <div class="row">
                <div class="col-4 col-md-2">Email</div>
                <div class="col-8 col-md-10">: support@efunding.id</div>
              </div>
            </div>
          </div>
          <div>
            <p class="mt-4 text-white fw-bold">Ikuti Sosial Media Kami</p>
            <div class="social-media-container">
              <a
                href="https://www.instagram.com/efunding.id"
                target="_blank"
                rel="noopener noreferrer"
                class="text-white"
              >
                <img :src="InstagramIcon" alt="icon-instagram" />
              </a>
              <a
                href="https://www.facebook.com/efundingsharia"
                target="_blank"
                rel="noopener noreferrer"
                class="text-white"
              >
                <img :src="FacebookIcon" alt="icon-facebook" />
              </a>
              <a
                href="https://www.linkedin.com/in/efunding-syariah-a14115251"
                target="_blank"
                rel="noopener noreferrer"
                class="text-white"
              >
                <img :src="LinkedinIcon" alt="icon-linkedin" />
              </a>
              <a
                href="https://www.youtube.com/@efundingTV"
                target="_blank"
                rel="noopener noreferrer"
                class="text-white"
              >
                <img :src="YoutubeIcon" alt="icon-youtube" />
              </a>
            </div>
          </div>
        </div>

        <!-- Kanan -->
        <div class="col-12 col-md-6 mb-4">
          <div class="row">
            <div class="col-4">
              <h5>Efunding</h5>
              <ul class="list-unstyled">
                <li><a href="/tentang-kami" class="text-white">Tentang Kami</a></li>
                <li><a href="https://news.efunding.id/" class="text-white" target="_blank" rel="noopener noreferrer">Blog</a></li>
                <li><a href="/hubungi-kami" class="text-white">Hubungi Kami</a></li>
              </ul>
            </div>
            <div class="col-4">
              <h5>Layanan</h5>
              <ul class="list-unstyled">
                <li><a href="/list-produk-tabungan" class="text-white">Tabungan</a></li>
                <li><a href="/list-produk-deposito" class="text-white">Deposito</a></li>
                <li><span class="text-white" style="opacity: 0.5;">Pembiayaan</span></li>
                <!-- <li><a href="#" class="text-white">Pembiayaan</a></li> -->
              </ul>
            </div>
            <div class="col-4">
              <h5>Bantuan</h5>
              <ul class="list-unstyled">
                <li><a href="/faq" class="text-white">FAQ</a></li>
                <li><a href="/syarat-dan-ketentuan" class="text-white">Syarat dan Ketentuan</a></li>
                <li><a href="/kebijakan-privasi" class="text-white">Kebijakan Privasi</a></li>
                <li>
                  <a href="/whistleblower" class="text-white">Whistleblowing System</a>
                </li>
              </ul>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-4">
              <div class="mt-4 affiliation-logo">
                <h6 class="text-white my-0" style="text-transform: capitalize; font-size: 16px; font-weight: 400;">Bagian dari:</h6>
                <img :src="AfsiLogo" alt="AFSI Logo" />
                <img :src="AftechLogo" alt="AFTECH Logo" />
              </div>
            </div>  
            <div class="col-12 col-sm-4">
              <div class="mt-4 partner-logo">
                <h6 class="text-white my-0" style="text-transform: capitalize; font-size: 16px; font-weight: 400;">Partner Resmi:</h6>
                <img :src="HimbarsiLogo" alt="HIMBARSI Logo" />
              </div>
            </div>
            <div class="col-12 col-sm-4">
              <div class="mt-4 iso-logo">
                <h6 class="text-white my-0" style="text-transform: capitalize; font-size: 16px; font-weight: 400;">Tersertifikasi:</h6>
                <div class="d-flex align-items-center mt-2" style="gap: 8px;">
                  <img :src="IsoLogo" alt="ISO 27001:2022" style="max-height: 50px; width: auto;" />
                  <div class="text-white" style="font-size: 12px; line-height: 1.3;">
                    <div class="fw-bold">ISO 27001:2022</div>
                    <div style="font-size: 11px;">Cert No: 2025-4-0269</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-12">
          <p class="text-white fw-bold mb-1"><strong>Disclaimer:</strong></p>
          <p class="text-white mb-0" style="text-align: justify">
            Efunding merupakan penyelenggara agregasi jasa keuangan yang terdaftar di OJK. Oleh karena itu, produk dan/atau layanan jasa keuangan yang ditawarkan bukan merupakan produk dan/atau layanan jasa keuangan yang diterbitkan oleh Efunding dan Efunding tidak bertanggung jawab atas tuntutan dan risiko terkait produk dan/atau layanan LJK dan/atau pihak yang melakukan kegiatan di sektor jasa keuangan.
          </p>
        </div>
      </div>
      <div class="text-center pb-3 copyright-container">
        <small>Efunding © 2026 All Rights Reserved</small>
      </div>
    </div>
  </footer>
</template>

<script>
// Assets
import EfundingWhiteLogo from "../../assets/images/landing_page/img-logo-efunding-white.png";
import AftechLogo from "../../assets/images/landing_page/img-logo-aftech.png";
import AfsiLogo from "../../assets/images/landing_page/img-logo-afsi.png";
import HimbarsiLogo from "../../assets/images/landing_page/img-logo-himbarsi.svg";
import IsoLogo from "../../assets/images/LOGO_ISO_2.png";
import InstagramIcon from "../../assets/images/landing_page/ic-instagram.svg";
import FacebookIcon from "../../assets/images/landing_page/ic-facebook.svg";
import TiktokIcon from "../../assets/images/landing_page/ic-tiktok.svg";
import LinkedinIcon from "../../assets/images/landing_page/ic-linkedin.svg";
import YoutubeIcon from "../../assets/images/landing_page/ic-youtube.svg";

export default {
  name: "NewFooterClient",
  data() {
    return {
      EfundingWhiteLogo,
      InstagramIcon,
      FacebookIcon,
      TiktokIcon,
      LinkedinIcon,
      YoutubeIcon,
      AftechLogo,
      AfsiLogo,
      HimbarsiLogo,
      IsoLogo,
    };
  },
};
</script>

<style scoped>
footer {
  background-color: #13346c;
  padding-bottom: 1rem;
}
h5 {
  letter-spacing: 0;
  font-weight: 600;
  color: white;
  text-transform: capitalize;
  font-size: 20px;
  margin-bottom: 24px;
}
.text-white {
  color: white;
}
.list-unstyled {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.address-container {
  display: flex;
  flex-direction: column;
}
.copyright-container {
  background-color: #f7bd3a;
  color: #13346c;
  padding-top: 16px;
  border-radius: 100px;
}
.social-media-container {
  display: flex;
  gap: 16px;
  align-items: center;
}
.social-media-container .icon-disabled {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: not-allowed;
  pointer-events: none;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
}
.social-media-container .icon-disabled img {
  width: 64px;
  height: 64px;
}
.social-media-container .mini-ribbon-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}
.social-media-container .mini-ribbon-text {
  display: block;
  text-align: center;
  font-size: 4.5px;
  font-weight: 700;
  color: #13346c;
  background-color: #f7bd3a;
  text-transform: uppercase;
  padding: 2px 0;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 56px;
  transform: translate(-50%, -50%) rotate(45deg) translateY(-13px);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  letter-spacing: 0.1px;
  white-space: nowrap;
}
.container {
  max-width: 90%;
}

.partner-logo img,
.affiliation-logo img,
.iso-logo img {
  max-width: 150px;
  height: auto;
}

@media (max-width: 768px) {
  .partner-logo img,
  .affiliation-logo img,
  .iso-logo img {
    max-width: 100px;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing-page/newFooterClient.vue